import React from 'react';
import { graphql } from 'gatsby';
import WebTab from './_code-web';
import ReactNativeTab from './_code-reactnative';
import AndroidTab from './_code-android';
import AppleTab from './_code-apple';
import { PageHero, PageWithSubNav, PlatformTabs } from '../../../../components';
import pageHeroData from '../../../../data/pages/components.yml';

const IndexPage = ({ data }) => {
  return (
    <PageWithSubNav
      pageType="code"
      title="Button"
      designCode
      subnav="components">
      <PageHero heroData={pageHeroData} tierTwo="Buttons" tierThree="Button" />

      <PlatformTabs
        platforms={{
          web: <WebTab />,
          reactnative: <ReactNativeTab />,
          android: <AndroidTab data={data} />,
          apple: <AppleTab />,
        }}
      />
    </PageWithSubNav>
  );
};

export default IndexPage;

export const query = graphql`
  query androidButtonCode($type: String = "/Buttons/") {
    ...colorDataCode
  }
`;
